import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Form from "../Form/Form.jsx";
import FormEmailInput from "../Form/FormEmailInput.jsx";
import FormTextField from "../Form/FormTextField.jsx";
import FormAutocomplete from "../Form/FormAutocomplete.jsx";
import SubmitButton from "../Form/SubmitButton.jsx";
import DsButton from "../../theme/components/Button.jsx";
import { MultilineText } from "./DetailViewComponents.jsx";

const validationSchema = yup.object({
  subject: yup.string().required("Betreff ist erforderlich"),
  body: yup.string(),
  forward_to: yup
    .array()
    .of(yup.string().email())
    .min(1, "Mindestens ein Empfänger muss angegeben werden"),
  forward_cc: yup.array().of(yup.string().email()),
  forward_bcc: yup.array().of(yup.string().email()),
  attachments: yup.array().of(yup.number()).notRequired(),
});

const ForwardCommunicationForm = ({
  defaultValues,
  attachmentOptions,
  communication,
  onSubmit,
  onCancel,
  disabled = false,
}) => {
  return (
    <Form
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      resolver={yupResolver(validationSchema)}
      mode="onChange"
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
        <FormEmailInput name="forward_to" label="An" disabled={disabled} />

        <FormEmailInput
          name="forward_cc"
          label="CC Kopie an"
          disabled={disabled}
        />

        <FormEmailInput
          name="forward_bcc"
          label="BCC Kopie an"
          disabled={disabled}
        />

        <FormTextField
          name="subject"
          label="Betreff"
          fullWidth
          disabled={disabled}
        />

        <FormTextField
          name="body"
          label="Weiterleitungstext"
          helperText="Zusätzlicher Text, der über der weitergeleiteten Mitteilung eingefügt wird"
          multiline
          rows={4}
          fullWidth
          disabled={disabled}
        />

        {attachmentOptions && attachmentOptions.length > 0 && (
          <FormAutocomplete
            name="attachments"
            label="Anlagen"
            multiple
            options={attachmentOptions}
            transformValue={(option) => option?.id ?? null}
            disabled={disabled}
          />
        )}

        <MultilineText value={communication?.beschreibung} />

        <Box
          sx={{ display: "flex", gap: 2, justifyContent: "flex-end", pt: 1 }}
        >
          <DsButton variant="tertiary" onClick={onCancel}>
            Abbrechen
          </DsButton>
          {!disabled && <SubmitButton>Weiterleiten</SubmitButton>}
        </Box>
      </Box>
    </Form>
  );
};

ForwardCommunicationForm.propTypes = {
  defaultValues: PropTypes.shape({
    subject: PropTypes.string,
    body: PropTypes.string,
    forward_to: PropTypes.arrayOf(PropTypes.string),
    forward_cc: PropTypes.arrayOf(PropTypes.string),
    forward_bcc: PropTypes.arrayOf(PropTypes.string),
    attachments: PropTypes.array,
  }).isRequired,
  communication: PropTypes.shape({
    id: PropTypes.number,
    beschreibung: PropTypes.string,
  }),
  attachmentOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string,
    })
  ),
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ForwardCommunicationForm;
